import React from "react";

// Shared section shell: title + short description, hairline top border.
const Section = ({ id, title, subtitle, children }) => (
  <section id={id} className="border-line scroll-mt-20">
    <div className="mx-auto max-w-content px-6 py-10 md:py-14">
      <div className="mb-8">
        <h2 className="text-2xl font-bold tracking-tight md:text-3xl">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 max-w-prose text-sm text-muted">{subtitle}</p>
        )}
      </div>
      {children}
    </div>
  </section>
);

export default Section;
